import { doc, getDoc, getDocs, query, where } from 'firebase/firestore';

import { FSCollections } from '@providers/firestoreProvider';
import { DemmiFS, Logger } from '@subhanhabib/demmilib';

import { db } from '../../../../firebase';
import { FSCollectionNames } from '../networkService.helper';

export class FSCustomerAuth {
  static _getDocByAuth = async (
    authUID: string,
    provider: string,
  ): Promise<DemmiFS.User | undefined> => {
    const q = query(
      FSCollections.Users,
      where(`fb_authProviders.${provider}.uid`, '==', authUID),
    );
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) return;
    if (querySnapshot.size !== 1) return;
    return {
      docID: querySnapshot.docs[0].id,
      ...(querySnapshot.docs[0].data() as DemmiFS.FSUser),
    };
  };

  static _getDocByID = async (
    customerDocID: string,
  ): Promise<DemmiFS.User | undefined> => {
    const docSnap = await getDoc(
      doc(db, FSCollectionNames.USERS, customerDocID),
    );
    if (docSnap.exists()) {
      return {
        docID: docSnap.id,
        ...(docSnap.data() as DemmiFS.FSUser),
      };
    } else Logger({ messages: ['No such document'] }, this._getDocByID);
    return undefined;
  };

  static _getDocID = async (
    authUID: string,
    provider: DemmiFS.AuthProviderHelper.FBAuthProvider,
  ): Promise<string | undefined> => {
    Logger({ objs: { authUID, provider } }, this._getDocID);
    return this._getDocByAuth(authUID, provider).then(doc => doc?.docID);
  };
}
